import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { ISignalRService } from 'src/app/@framework/signalr/signalr-service.interface';

class UnlimitedRetryPolicy implements signalR.IRetryPolicy {
  constructor(private readonly retryDelays: number[], private readonly maxRetryDelay: number) {}

  nextRetryDelayInMilliseconds(retryContext: signalR.RetryContext): number {
    const index = retryContext.previousRetryCount;
    return index < this.retryDelays.length ? this.retryDelays[index] : this.maxRetryDelay;
  }
}

@Injectable({
  providedIn: 'root'
})
export class SignalRService extends ISignalRService {

  protected connection: signalR.HubConnection;
  private subjects: Subject<any>[] = [];

  constructor() {
    super();
  }

  public buildConnection(hubUrl) {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl)
      .configureLogging(signalR.LogLevel.Information)
      .withAutomaticReconnect(new UnlimitedRetryPolicy([0, 2000, 10000, 30000], 30000))
      .build();

    this.connection.onreconnecting(() => {
      this.connectionEstablished$.next(false);
    });

    this.connection.onreconnected(() => {
      this.connectionEstablished$.next(true);
    });

    this.connection.onclose(() => {
      this.connectionEstablished$.next(false);
    });
  }

  public connect() {
    this.connection
      .start()
      .then(() => {
        this.connectionEstablished$.next(true);
      })
      .catch(() => {
        this.connectionEstablished$.next(false);
      });
  }

  public disconnect() {
    this.connection.stop().catch(() => {});
    this.connectionEstablished$.next(false);
  }

  public registerDefaultServerEvents () {
    this.connection.on('__connectedEvent', () => {

    });

    this.connection.on('forcePageReload', () => {
      window.onbeforeunload = null;
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    });
  }

  public async joinGroup(groupName: string) {
    await this.connection.invoke("JoinGroup", groupName);
  }
}
